<template>
  <span class="d-flex">
    <div class="tv-box" v-for="(number, index) in numbers" :key="index">
      <img :src="img(number)">
    </div>
  </span>
</template>
<script>
export default {
  name: 'DisplayResult',
  props: {
    result: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    numbers() {
      if(this.result)
        return this.result.split('')

      return []
    }
  },
  methods: {
    img(number) {
      return require(`@/assets/${number}.png`)
    }
  }
}
</script>
<style lang="scss" scoped>
.tv-box {
  background-image: url('../../assets/tv-box.png') !important;
  padding-top: 10px;
  padding-right: 10px;
}

@media only screen and (max-width:700px) {
  .tv-boxs {
    .tv-box {
      padding-top: 8px;
      img {
        width: 40px;
      }
    }
  }
}

@media only screen and (max-width:600px) {
  .tv-boxs {
    .tv-box {
      img {
        width: 35px;
      }
    }
  }
}

@media only screen and (max-width:500px) {
  .tv-boxs {
    .tv-box {
      padding-top: 5px;
      padding-right: 5px;
      img {
        width: 30px;
      }
    }
  }
}
</style>
